import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "categoryFilter",
    "regionFilter",
    "dateFilter",
    "dateInput",
    "dateToInput",
  ]

  connect() {
    this.timeout = null
    this.form = document.getElementById("concert-form")
    
    if (this.hasDateInputTarget) {
      this.setupDateInput()
    }
  }
  
  setupDateInput() {
    const dateButton = document.querySelector('[data-dialog-target-id-value="#performance-filter-date"]')
    
    if (dateButton) {
      dateButton.addEventListener('click', () => {
        if (this.datePickerTimer) {
          clearTimeout(this.datePickerTimer)
        }
        
        const attemptSequence = [400, 600, 800]
        
        attemptSequence.forEach(delay => {
          this.datePickerTimer = setTimeout(() => {
            const dialog = document.getElementById('performance-filter-date')
            if (dialog && dialog.classList.contains('show') && this.hasDateInputTarget) {
              this.dateInputTarget.focus()
              this.showDatePicker({ target: this.dateInputTarget })
            }
          }, delay)
        })
      })
    }
  }

  submitForm() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.form.requestSubmit()
    }, 300)
  }

  showDatePicker(e) {
    if (typeof e.target.showPicker === "function") {
      try {
        e.target.showPicker()
      } catch (error) {
        // just catch this error in case the browser prevents showing the Datepicker
      }
    }
  }
}
